import dedent from 'dedent';
import {z} from 'zod';
import {defineToolRegistryManifest} from '../../types/base-tool-types';

const toolName = 'write-remote-file' as const;

const argumentZod = z.object({
  path: z
    .string()
    .describe(
      'The path of the file to write, relative to the project root (e.g. "package.json", "component-id-1.webflow.tsx")'
    ),

  content: z.string().describe('The content of the file to write'),
});

export const writeRemoteFileTool = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Write component',
  prettyStatus: {
    executing: 'Creating component',
    executed: 'Created component',
    failed: 'Failed to create component',
    partial: 'Created component with errors',
  },
  llmTool: {
    name: toolName,
    description: dedent`
      Writes the contents of a file to the code component sandbox environment. The file path is relative to the project root.

      Use this tool to create new files or completely rewrite existing files in the sandbox. This is especially useful for:
      - Creating new source files from scratch
      - Making very large changes (>50% of the file)

      For small to medium edits to existing files, prefer the available targeted file-editing tool to avoid rewriting unchanged code.

      Only files containing text can be written by this tool.
    `,
    inputSchema: argumentZod,
  },
  type: 'designer',
  permission: [{resource: 'SiteSymbol', action: 'modify'}],
  confirmBeforeExecuting: false,
  timeout: 15000,
});
